import axios from 'axios';

const token = JSON.parse(sessionStorage.getItem("nln-virtual-library-user-token"));
    //  const token = jwt ? jwt.data.token : null;
    //  console.log(token);

export default axios.create({
   
    baseURL: "https://nigeriana-api-staging.herokuapp.com/api/v1",
    headers: {
      "Access-Control-Allow-Origin": "*", 
      'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem("nln-virtual-library-user-token"))}`,
      // 'Content-Type': 'multipart/form-data'
    },
  });




 